import ms from 'ms';

import { QK_FETCH_PLATFORM_SETTINGS, settingApi } from '~/requests/settingApi';

export const platformSettingsOptions = () => {
  return {
    queryKey: [QK_FETCH_PLATFORM_SETTINGS],
    queryFn: () => {
      return settingApi.getPlatformSettings({});
    },
    staleTime: ms('5m'),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  };
};
